import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MasterService } from '../../master.service';
import { AppSettings } from '../../../../app.settings';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
  public form: UntypedFormGroup;
  public syncStartSequence = true;
  public moduleNameList = ['WO', 'PRN', 'GRN', 'BOQ', 'PI', 'DC', 'SI', 'PO','LOI','SO', 'WCO', 'PRODUCT', 'WOAMENDMEND', 'BOQAMENDMEND',
     'STOCKADJUSTMENT','SUBCONTRACTORWO','MATSUBCONTRACTORWO','STOCK_CONSUMPTION','CONTRACTOR_BILL_ENTRY','SITE_BUDGETING',
    'PROFORMA_INVOICE','SALES_INVOICE','QUOTATION_REQUEST','QUOTATION_ENTRY','SITE_PLANNING','STOCK_TRANSFER','SUPPLIER_MATERIAL_RETURN',
    'SUPPLIER_ADVANCE_PAYMENT','CONTRACTOR_ADVANCE_PAYMENT','CLIENT_RECEIPT_PAYMENT','CLIENT_ADVANCE_PAYMENT','CONTRACTOR_RECEIPT_PAYMENT'
  ,'CONTRACTOR_RETENTION_PAYMENT','CONTRACTOR_TDS_PAYMENT','EXPENSE', 'TAX_INVOICE'];
  constructor(public formBuilder: UntypedFormBuilder, public snackBar: MatSnackBar,
    private masterService: MasterService, public dialogRef: MatDialogRef<AddComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public appSettings:AppSettings,) {
      dialogRef.disableClose = true;
    this.form = this.formBuilder.group({
      'id': [''],
      'moduleName': ['', Validators.required],
      'prefix': ['', Validators.maxLength(6)],
      'startSequence': ['',[Validators.required, Validators.maxLength(6),Validators.pattern(this.appSettings.onlyNumber)]],
      'sequenceNumber': ['',[Validators.required, Validators.maxLength(6),Validators.pattern(this.appSettings.onlyNumber)]],
      'suffix': ['', Validators.maxLength(6)]
    });

    this.form.controls.sequenceNumber.valueChanges.subscribe((value) => {
      if (this.syncStartSequence) {
        this.form.controls.startSequence.setValue(value, { emitEvent: false });
      }
    });

    this.form.controls.startSequence.valueChanges.subscribe(() => {
      this.syncStartSequence = false;
    });
  }

  ngOnInit(): void {
    this.syncStartSequence = this.data?.startSequence == null;
    if (this.data) {
      this.form.controls.id.setValue(this.data.id);
      this.form.controls.moduleName.setValue(this.data.moduleName);
      this.form.controls.prefix.setValue(this.data.prefix);
      this.form.controls.startSequence.setValue(this.data?.startSequence ?? this.data?.sequenceNumber, { emitEvent: false });
      this.form.controls.sequenceNumber.setValue(this.data.sequenceNumber);
      this.form.controls.suffix.setValue(this.data?.suffix);
    }
  }

  close(): void {
    this.dialogRef.close();
  }

}
